import { styled, TableCell } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.MuiTableCell-head`]: {
    backgroundColor: theme.palette.action.hover,
    cursor: "pointer",
    "&:hover .MuiTableSortLabel-icon": {
      opacity: 1,
    },
    zIndex: 1,
  },
  [`&.MuiTableCell-body`]: {
    fontSize: 14,
    zIndex: 0,
  },
}));

export default StyledTableCell;
